import React from 'react';
import {
  Snackbar as SnackbarNative,
  SnackbarProps as SnackbarPropsNative
} from '@material-ui/core';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

export interface SnackbarProps {
  duration?: number;
  message: string;
  location: SnackbarPropsNative['anchorOrigin'];
  type: AlertProps['severity'];
  visibility: boolean;
  onClose(): void;
}

export const Snackbar = (props: SnackbarProps) => {
  const {
    duration = 8000,
    message,
    location,
    visibility,
    type,
    onClose
  } = props;

  return (
    <SnackbarNative
      anchorOrigin={location}
      open={visibility}
      autoHideDuration={duration}
      onClose={onClose}
    >
      <MuiAlert
        elevation={6}
        variant="filled"
        onClose={onClose}
        severity={type}
      >
        {message}
      </MuiAlert>
    </SnackbarNative>
  );
};
